var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDownload = function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "currentColor",
    style: {
      color: "#36abff"
    }
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.75 9.44V5.25a.75.75 0 0 0-1.5 0v4.19l-.97-.97a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.06 0l2.25-2.25a.75.75 0 0 0-1.06-1.06l-.97.97Zm-5.78 4.59c.14.141.331.22.53.22h9a.75.75 0 0 0 .75-.75v-2.25a.75.75 0 0 0-1.5 0v1.5h-7.5v-1.5a.75.75 0 0 0-1.5 0v2.25c0 .199.079.39.22.53Z",
    clipRule: "evenodd"
  })));
};
export default SvgDownload;